import { AxiosResponse } from "axios";
import {
  SET_INTEGRATIONS,
  SET_INTEGRATION,
  SET_ERRORMSG,
  SET_CONNECT_INTEGRATION,
} from "@/store/mutation-types";
import {
  CLEAR_INTEGRATION_ISLOADING,
  CONNECT_INTEGRATION,
  DELETE_INTEGRATION,
  DISCONNECT_INTEGRATION,
  EDIT_INTEGRATION,
  GET_INTEGRATIONS,
  REGISTER_INTEGRATION,
} from "@/store/action-types";
import { StateObject } from "@/dtos/State.dto";
import Integration from "@/services/integrations/integration";
import { Module } from "vuex";
import {
  EditIntegration,
  RegisterIntegration,
  GetIntegration,
  ConnectIntegration,
} from "@/dtos/Integration.dto";

const integration: Module<any, {}> = {
  state: {
    integration: {
      data: null,
      isLoading: false,
    },
    integrations: {
      data: null,
      isLoading: false,
    },
    connectIntegration: {
      data: null,
      isLoading: false,
    },
  },
  getters: {
    integration: (state: { integration: any }) => state.integration,
    integrations: (state: { integrations: any }) => state.integrations,
    connectIntegration: (state: { connectIntegration: any }) => state.connectIntegration,
  },
  mutations: {
    [SET_INTEGRATION]: (
      state: { integration: StateObject },
      payload: { data: null; status: any; isLoading: any }
    ) => {
      if (payload.data != null) state.integration.data = payload.data;
      state.integration.isLoading = payload.isLoading;
    },
    [SET_INTEGRATIONS]: (
      state: { integrations: StateObject },
      payload: { data: null; status: any; isLoading: any }
    ) => {
      if (payload.data != null) state.integrations.data = payload.data;
      state.integrations.isLoading = payload.isLoading;
    },
    [SET_CONNECT_INTEGRATION]: (
      state: { connectIntegration: StateObject },
      payload: { data: null; status: any; isLoading: any }
    ) => {
      if (payload.data != null) state.connectIntegration.data = payload.data;
      state.connectIntegration.isLoading = payload.isLoading;
    },
  },
  actions: {
    [CONNECT_INTEGRATION]: async ({ commit }: any, payload: any) => {
      commit(SET_CONNECT_INTEGRATION, { data: payload, isLoading: true });

      const result: AxiosResponse = await Integration.connectIntegration(
        payload as ConnectIntegration
      );

      if (result) {
        if (result.data.status) {
          commit(SET_CONNECT_INTEGRATION, { data: null, isLoading: false });
          return result.data.data;
        }
        commit(SET_CONNECT_INTEGRATION, { data: null, isLoading: false });
        commit(SET_ERRORMSG, result.data.msg);
        return false;
      } else {
        commit(SET_CONNECT_INTEGRATION, { data: null, isLoading: false });
        return false;
      }
    },
    [DISCONNECT_INTEGRATION]: async ({ commit }: any, payload: any) => {
      commit(SET_CONNECT_INTEGRATION, { data: payload, isLoading: true });

      const result: AxiosResponse = await Integration.disconnectIntegration(
        payload as ConnectIntegration
      );

      if (result) {
        if (result.data.status) {
          commit(SET_CONNECT_INTEGRATION, { data: null, isLoading: false });
          return result.data.data;
        }
        commit(SET_CONNECT_INTEGRATION, { data: null, isLoading: false });
        commit(SET_ERRORMSG, result.data.msg);
        return false;
      } else {
        commit(SET_CONNECT_INTEGRATION, { data: null, isLoading: false });
        return false;
      }
    },
    [REGISTER_INTEGRATION]: async ({ commit }: any, payload: any) => {
      commit(SET_INTEGRATION, { data: null, isLoading: true });

      const result: AxiosResponse = await Integration.registerIntegration(
        payload as RegisterIntegration
      );

      if (result) {
        if (result.data.status) {
          commit(SET_INTEGRATION, { data: result.data.data, isLoading: false });
          return true;
        }
        commit(SET_INTEGRATION, { data: null, isLoading: false });
        commit(SET_ERRORMSG, result.data.msg);
        return false;
      } else {
        commit(SET_INTEGRATION, { isLoading: false });
        return false;
      }
    },
    [GET_INTEGRATIONS]: async ({ commit }: any, payload: any) => {
      commit(SET_INTEGRATIONS, { data: null, isLoading: true });

      const result: AxiosResponse = await Integration.getIntegrations(payload as GetIntegration);

      if (result) {
        if (result.data.status) {
          commit(SET_INTEGRATIONS, {
            data: result.data.data,
            isLoading: false,
          });
          return true;
        }
        commit(SET_INTEGRATIONS, { data: null, isLoading: false });
        commit(SET_ERRORMSG, result.data.msg);
        return false;
      } else {
        commit(SET_INTEGRATIONS, { isLoading: false });
        return false;
      }
    },
    [EDIT_INTEGRATION]: async ({ commit }: any, payload: any) => {
      commit(SET_INTEGRATION, { data: null, isLoading: true });

      const result: AxiosResponse = await Integration.editIntegration(payload as EditIntegration);

      if (result) {
        if (result.data.status) {
          commit(SET_INTEGRATION, { data: result.data.data, isLoading: false });
          return true;
        }
        commit(SET_INTEGRATION, { data: null, isLoading: false });
        commit(SET_ERRORMSG, result.data.msg);
        return false;
      } else {
        commit(SET_INTEGRATION, { isLoading: false });
        return false;
      }
    },
    [DELETE_INTEGRATION]: async ({ commit }: any, payload: string) => {
      commit(SET_INTEGRATION, { data: { id: payload }, isLoading: true });

      const result: AxiosResponse = await Integration.deleteIntegration(payload);

      if (result) {
        if (result.data.status) {
          commit(SET_INTEGRATION, { data: result.data.data, isLoading: false });
          return true;
        }
        commit(SET_INTEGRATION, { data: null, isLoading: false });
        commit(SET_ERRORMSG, result.data.msg);
        return false;
      } else {
        commit(SET_INTEGRATION, { isLoading: false });
        return false;
      }
    },
    [CLEAR_INTEGRATION_ISLOADING]: ({ commit }) => {
      commit(SET_INTEGRATION, { isLoading: false });
      commit(SET_INTEGRATIONS, { isLoading: false });
    },
  },
};

export default integration;
